<div class=" card4 p-1   ">

    <div class="p-1">
        <div class="size15">Dernier prix d'achat</div>
        <div class=" size24">{{ formatPrice(lastPrixHt) }} TND</div>
    </div>
</div>
